import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaBoxesStacked, FaGear, FaHouse, FaRegImages, FaShapes } from 'react-icons/fa6';
import { MdApps } from 'react-icons/md';
import { useTranslation } from 'react-i18next';
import Logo from '@components/ui/Logo/Logo';
import MenuDesktop from '@components/ui/MenuDesktop/MenuDesktop';
import { useEffect } from 'react';
import { loadProduct, unloadProduct } from '@slices/productSlice';
import { updateCoinsList } from '@slices/cryptoSlice';
import { updateStocksList } from '@slices/stockSlice';
import Product from '@ltypes/product';
import ProductService from '@services/ProductService';
import FloatingMenu from '../FloatingMenu/FloatingMenu';
import './Header.scss';

type HeaderProps = {};

function Header(props: HeaderProps) {
    const user = useSelector((state: any) => state.user);
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const inConfigModel = location.pathname.substring(0, 3) === '/m/';
    const split = location.pathname.split('/');
    split.shift();

    const product: Product = useSelector((state: any) => state.product);

    useEffect(() => {
        if((inConfigModel && product === null) || (!inConfigModel && product !== null)) {
            if(!inConfigModel) {
                dispatch(unloadProduct());
            }
            else {
                const productId: string = split?.[1];
                if(productId.length) {
                    const service: ProductService = new ProductService();
                    service.get(productId).then((data: any) => {
                        dispatch(loadProduct(data.body));
                    });
                }
            }
        }
    }, [location.pathname]);

    useEffect(() => {
        if(!user) return;
        const service: ProductService = new ProductService();
        service.call('GET', '/assets/cryptocurrencies').then((data: any) => {
            dispatch(updateCoinsList(data.body));
        });
        service.call('GET', '/assets/stocks').then((data: any) => {
            dispatch(updateStocksList(data.body));
        });
    }, [user]);

    return (
        <>
            {location.pathname.includes('/m/') && (
                <FloatingMenu/>
            )}

            <header>
                <div className="row g-0">
                    <div className="col-sm-12">
                        <nav className="navbar">
                            <div className="col my-logo" onClick={() => navigate('/')}>My <Logo size="1.4rem"/></div>
                            <div className="col-auto">
                                {/* {user && <Account user={user}/>} */}
                                {/* {user && <ListLumebas/>} */}
                            </div>
                        </nav>
                    </div>
                    <div className="d-none d-md-block col-sm-12">
                        <MenuDesktop items={[
                            // {
                            //     label: t('menu.home'),
                            //     icon: FaHouse,
                            //     to: '/',
                            //     active: location.pathname === '/' || location.pathname === '/forgotpassword',
                            // },
                            // {
                            //     label: t('menu.dashboard'),
                            //     icon: MdApps,
                            //     to: `/m/${split?.[1]}/dashboard`,
                            //     active: inConfigModel && split?.[2] === 'dashboard', // 32 pour le md5 du model
                            //     disabled: !inConfigModel,
                            // },
                            // {
                            //     label: t('menu.groups'),
                            //     icon: FaShapes,
                            //     to: `/m/${split?.[1]}/groups`,
                            //     active: inConfigModel && split?.[2] === 'groups',
                            //     disabled: !inConfigModel,
                            // },
                            {
                                label: t('menu.lumebas'),
                                icon: FaBoxesStacked,
                                to: '/',
                                active: location.pathname === '/' || location.pathname.includes('/m/'),
                            },
                            {
                                label: t('menu.screenshots'),
                                icon: FaRegImages,
                                to: '/screenshots',
                                active: location.pathname === '/screenshots',
                            },
                            {
                                label: t('menu.settings'),
                                icon: FaGear,
                                to: '/settings',
                                active: location.pathname.includes('/settings') || location.pathname === '/changelog',
                            },
                        ]}/>
                    </div>
                </div>
            </header>
        </>
    );
}

export default Header;
